/**
 * Safely fetches a meta tag's content.
 * @param {String} name The meta tag's name.
 * @returns {String|undefined}
 */
const getMetaTagContent = (name) => {
    if (typeof document === 'undefined') {
        return;
    }

    const tag = document.querySelector(`meta[name="${name}"]`);

    return (tag && tag.getAttribute('content')) || undefined;
};

export default getMetaTagContent;
